"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.numberTween = exports.debugRect = exports.debugBase64Image = exports.blobToBase64 = exports.uniqueArray = exports.wait = exports.periodicChecker = void 0;
const tslib_1 = require("tslib");
const periodicChecker = (checker, ms = 1000) => {
    return new Promise(resolve => {
        const routine = () => {
            const result = checker();
            if (typeof result === "boolean") {
                resolve(result);
            }
            else {
                setTimeout(routine, ms);
            }
        };
        routine();
    });
};
exports.periodicChecker = periodicChecker;
const wait = (ms) => new Promise(r => setTimeout(r, ms));
exports.wait = wait;
const uniqueArray = (result) => result.reduce((acc, curr) => (acc.includes(curr) ? acc : [curr, ...acc]), []);
exports.uniqueArray = uniqueArray;
const blobToBase64 = (blob) => tslib_1.__awaiter(void 0, void 0, void 0, function* () {
    return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.onloadend = () => { var _a, _b; return resolve((_b = (_a = reader.result) === null || _a === void 0 ? void 0 : _a.toString()) !== null && _b !== void 0 ? _b : null); };
        reader.onerror = () => reject(null);
        reader.onabort = () => reject(null);
        reader.readAsDataURL(blob);
    });
});
exports.blobToBase64 = blobToBase64;
const debugBase64Image = (base64, width, height) => {
    console.debug('%c.', `
    display: inline-block;
    font-size: 0;
    padding: ${height}px ${width}px 0 0;
    color: transparent;
    background: url(${base64}) no-repeat 0 0;
    background-size: ${width}px ${height}px;
    box-sizing: content-box;
    border: solid 1px red;
`);
};
exports.debugBase64Image = debugBase64Image;
const debugRect = (rect, color) => {
    const highlighter = document.createElement('div');
    document.body.appendChild(highlighter);
    highlighter.style.position = 'absolute';
    highlighter.style.zIndex = '2000';
    highlighter.style.left = `${rect.x}px`;
    highlighter.style.top = `${rect.y}px`;
    highlighter.style.width = `${rect.width}px`;
    highlighter.style.height = `${rect.height}px`;
    highlighter.style.backgroundColor = color;
};
exports.debugRect = debugRect;
/**
 * Tweener
 * @param from
 * @param to
 * @param ms
 * @param callback
 * @returns Resolves when the tween is complete
 */
const numberTween = (from, to, ms, callback) => tslib_1.__awaiter(void 0, void 0, void 0, function* () {
    yield new Promise(resolve => {
        const startTime = Date.now();
        const animate = () => {
            const timeDiff = Date.now() - startTime;
            if (timeDiff >= ms) {
                callback(to);
                resolve();
            }
            else {
                callback(timeDiff / ms * (to - from) + from);
                requestAnimationFrame(animate);
            }
        };
        requestAnimationFrame(animate);
    });
});
exports.numberTween = numberTween;
